import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select-all-checkbox',
  templateUrl: './select-all-checkbox.component.html',
  styleUrls: ['./select-all-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class SelectAllCheckboxComponent {
  @Input() totalCount = 0;
  @Input() selectedCount = 0;
  @Output() readonly toggle = new EventEmitter<boolean>();

  get isChecked(): boolean {
    return this.selectedCount === this.totalCount && this.totalCount > 0;
  }

  get isIndeterminate(): boolean {
    return this.selectedCount > 0 && this.selectedCount < this.totalCount;
  }

  onChange(checked: boolean): void {
    this.toggle.emit(checked);
  }
}
